// This is a generated file. Don't edit.

export const PACKAGE_VERSION = "1.3.18";

export const clientInfo = {
  device: '',
  os_version: '',
  device_id: '',
  platform: 'desktop',
  clientType: 'web',
  version: PACKAGE_VERSION,
  language: 'vi',
  country: 'VN',
  revision: '10318',
}